export default __webpack_public_path__ + "39236a5bdc72fed48e892cb9fd01b341.svg";